import { useFormat } from '@ideavivat/vivat-2';
import usePurchaseOrder from '@/use/usePurchaseOrder';
import usePurchaseRequest from '@/use/usePurchaseRequest';

const { statusClassMap, statusTranslate } = usePurchaseOrder();
const { classMap, typeTranslate } = usePurchaseRequest();

export const code = {
  name: 'รหัสชิ้นส่วน',
  width: '20rem',
  filter: (val: string, row: { item: { [key: string]: any }; index: number }) => {
    if (row.item.code) return row.item.code;
    return row.item.bom_material_code;
  },
};

export const job_no = {
  name: 'Sub Job No.',
  width: '8rem',
  // eslint-disable-next-line
  filter: (val: any) => val ? val : '',
};

export default {
  types: {
    _selectorControls: {
      width: '2rem',
      class: 'text-center items-center',
    },
    // _editControls: {
    //   width: '3rem',
    // },
    _increment: {
      name: 'ลำดับ',
      width: '3rem',
      class: 'text-center',
    },
    po_code: {
      name: 'รหัส PO',
      width: '6rem',
      // eslint-disable-next-line
      filter: (val: string) => val ? val : '-',
    },
    status: {
      name: 'สถานะ',
      width: '6rem',
      filter: (val: string, row: { item: { [key: string]: any }; index: number }) => statusTranslate(val, row.item.amount, row.item.filled_amount, row.item.approved, row.item.manager_approved, row.item.chief_manager_approved, row.item.total_price),
      class: {
        text(val: string, row: { item: { [key: string]: any }; index: number }) {
          return statusClassMap(val, row.item.amount, row.item.filled_amount, row.item.approved, row.item.manager_approved, row.item.chief_manager_approved, row.item.total_price);
        },
      },
    },
    type: {
      name: 'ประเภท',
      width: '6rem',
      filter: (val: string, row: { item: { [key: string]: any }; index: number }) => typeTranslate(val),
      class: {
        text(val: string, row: { item: { [key: string]: any }; index: number }) {
          return classMap(val, true);
        },
      },
    },
    job_no,
    code,
    description: {
      name: 'Material',
      width: '8rem',
      class: 'text-left',
      // eslint-disable-next-line
      filter: (val: string, row: any) => row.item.name ? row.item.name : row.item.description,
    },
    amount: {
      name: 'จำนวน / รับแล้ว',
      width: '6rem',
      class: 'text-right',
      filter: (val: string) => parseFloat(val || '0').toLocaleString('th-TH', { minimumFractionDigits: 0, maximumFractionDigits: 2 }),
    },
    // department: {
    //   name: 'แผนก',
    //   width: '1fr',
    // },
    target_date: {
      name: 'กำหนดส่ง',
      width: '12rem',
      class: 'text-right',
      // eslint-disable-next-line
      filter: (val: string) => val ? useFormat.date(val).displayShortThaiDate() : '',
    },
    updated_at: {
      name: 'วันทำรายการล่าสุด',
      width: '12rem',
      class: 'text-right',
      // eslint-disable-next-line
      filter: (val: string) => val ? useFormat.date(val).displayShortThaiDateTime() : '',
    },
  },

  sortable: [
    'target_date',
    'updated_at',
    'description',
    'type',
  ],
};
